import { TFunction } from 'i18next';
import step1Image from '/public/store-products/landing/step1.png';
import step2Image from '/public/store-products/landing/step2.png';
import step3Image from '/public/store-products/landing/step3.png';

const images = [step1Image, step2Image, step3Image];

export const getHowItWorks = (t: TFunction) => {
  const steps = t('store.productPage.howItWorks', { returnObjects: true }) as Array<{
    title: string;
    text: string;
  }>;

  return steps?.map?.((step, index) => ({
    ...step,
    imageSrc: images[index]!,
  }));
};
